import React, { useEffect, useState, useCallback } from "react";
import Footer from "../../components/Footer/Footer";
import SecondaryButton from "../../components/Button/SecondaryButton";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { AccessoriesClass } from "../../APIs";
import Loading from "../../components/Loading/Loading";
import { Helmet } from "react-helmet";
import { Images } from "../../assets/assets";
import Header from "../../components/Header/Header";
import { useNotification } from "../../components/Toast/Notification";
import { useCart } from "../../components/CartContext/CartContext";
import CartModal from "../../components/ModalImtemAdded/ModalItemAdded";
import { Eye, ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";
import { AccessoryData } from "../../@types/accessory";
// TODO: change them
const AccessoriesProductPage = () => {
  const [selectedAcc, setSelectedRAcc] = useState<AccessoryData | undefined>(
    undefined
  );
  const [isInCart, setIsInCart] = useState<boolean>(false);
  const {
    cart,
    availableStock,
    getItemStock,
    handleIncrease,
    handleDecrease,
    isUpdating,
    isDecreasing,
  } = useCart();

  const { accessorylink } = useParams<{ accessorylink: string }>();
  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
  const encodedUrl = accessorylink ? accessorylink.replace(/-/g, " ") : "";
  const [stockLoading, setStockLoading] = useState<boolean>(true);

  const fetchRecipeById = useCallback(
    async (accessorylink: any) => {
      try {
        const { data, error } = await AccessoriesClass.getAccessoryByLink(
          accessorylink
        );

        if (data) {
          setSelectedRAcc(data);
          setSelectedProduct(data);
          if (data.sku) {
            setStockLoading(true);
            await getItemStock(data.sku);
            setStockLoading(false); // Set loading to false after fetching stock
          }
        } else {
          console.error("Error fetching Accessory by ID:", error);
          setStockLoading(false); // Ensure loading is reset on error
        }
      } catch (error) {
        console.error("Error fetching Accessory by ID:", error);
        setStockLoading(false); // Ensure loading is reset on error
      }
    },
    [getItemStock]
  );

  useEffect(() => {
    if (encodedUrl && !selectedAcc && !selectedProduct) {
      fetchRecipeById(encodedUrl);
    }
  }, [encodedUrl, fetchRecipeById, selectedAcc, selectedProduct]);

  const checkIfInCart = useCallback(() => {
    if (!selectedProduct || !cart || !Array.isArray(cart)) return false;

    const productInCart = cart.find(
      (item: any) =>
        item.sku === selectedProduct.sku || item.id === selectedProduct.id
    );

    if (productInCart) {
      setAddedProduct(productInCart);
      return true;
    }

    return false;
  }, [selectedProduct, cart]);

  useEffect(() => {
    setIsInCart(checkIfInCart());
  }, [cart, checkIfInCart, selectedProduct]);

  const capitalizeFirstLetter = (str: string | undefined) => {
    if (!str) return "";
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const [addedProduct, setAddedProduct] = useState<any | null>(null);
  const { addToCart } = useCart();
  const [isCartModalVisible, setIsCartModalVisible] = useState(false);
  const { notify } = useNotification();

  const handleAddToCart = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!selectedProduct) {
      notify("This product is undefined ", "warn");
      return; // Add an early return here
    }

    if (isInCart && addedProduct) {
      setIsCartModalVisible(true);
      return;
    }

    try {
      addToCart(selectedProduct, 1);

      const productToAdd = {
        ...selectedProduct,
        product_type: selectedProduct.product_type || "",
        name: selectedProduct.name,
        image: selectedProduct.image,
        price: selectedProduct.price,
        sku: selectedProduct.sku || "",
        item_quantity: 1,
      };

      setAddedProduct(productToAdd);
      setIsCartModalVisible(true);
      setIsInCart(true);
      notify(`${selectedProduct.name} successfully added to cart`, "success");
    } catch (error) {
      notify("Failed to add product to cart", "error");
      console.error("Error adding to cart:", error);
    }
  };

  const handleProductIncrease = () => {
    // setIsIncreasing(true);
    if (addedProduct) {
      // Only check addedProduct
      handleIncrease(addedProduct);
    }
    // setIsIncreasing(false);
  };

  const handleProductDecrease = () => {
    if (addedProduct) {
      // Only check addedProduct
      handleDecrease(addedProduct);
    }
  };

  const handleCartAction = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isInCart && selectedProduct?.sku) {
      getItemStock(selectedProduct?.sku);
      setIsCartModalVisible(true);
    }
  };
  return (
    <>
      <div>
        {selectedAcc ? (
          <>
            <Helmet>
              <meta charSet="utf-8" />
              <title>
                {selectedAcc.meta_title ||
                  capitalizeFirstLetter(selectedAcc.name)}
              </title>
              <meta
                name="description"
                content={
                  selectedAcc.meta_description ||
                  `${capitalizeFirstLetter(
                    selectedAcc.name
                  )} - SodaStream Accessory`
                }
              />
              <link
                rel="canonical"
                href={`https://www.sodastream.co.za/accessories/${accessorylink}`}
              />
            </Helmet>
            <Header
              title={capitalizeFirstLetter(selectedAcc.name)}
              textBackground="ACCESSORIES"
              backgroundImg={Images.AccessoriesBg}
            />

            <div className="bg-[#FFFFFF] text-start pl-6 ">
              <Breadcrumb
                items={[
                  { text: "HOME", href: "/" },
                  { text: "Accessories", href: "/accessories" },
                  { text: capitalizeFirstLetter(selectedAcc.name) },
                ]}
              />
            </div>

            <div>
              <section className="flex flex-col md:flex-row p-6">
                <div className="flex-1 p-4 m-2 rounded">
                  <div className="relative">
                    <div className="flex flex-col items-center justify-center">
                      <img
                        className="w-[140px] md:w-[200px] mx-auto"
                        src={selectedProduct.image}
                        alt={capitalizeFirstLetter(
                          selectedProduct.productlinkname
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1 p-4 rounded">
                  <h1 className="text-[rgb(0,93,110)] text-2xl font-semibold">
                    {capitalizeFirstLetter(selectedAcc.name)}
                  </h1>
                  <p className="text-[rgb(0,93,110)] text-[23px] mb-[15px]">
                    R {selectedAcc.price}
                  </p>
                  <p className="text-[rgb(0,93,110)] text-[14px] mb-[15px] italic">
                    * Price includes VAT
                  </p>
                  <p className="text-[rgb(0,93,110)] text-[16px] mb-[15px]">
                    {selectedAcc.description}
                  </p>
                  {!selectedAcc?.is_coming_soon && (
                    <p className="text-[rgb(0,93,110)] text-[16px]">
                      *Available in most retailers across Mzansi!
                    </p>
                  )}

                  {stockLoading ? (
                    <div className="mt-[-10%] inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-[#31526B] text-white">
                      <div className="w-2 h-2 rounded-full bg-white mr-1.5 animate-pulse"></div>
                      Checking stock...
                    </div>
                  ) : (
                    <div
                      className={`inline-flex  items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                        (availableStock || 0) > 0
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}>
                      {(availableStock || 0) > 0 ? (
                        <>
                          <span className="w-2 h-2 rounded-full bg-green-500 mr-1.5"></span>{" "}
                          In Stock
                        </>
                      ) : (
                        <>
                          <span className="w-2 h-2 rounded-full bg-red-500 mr-1.5"></span>{" "}
                          Out of Stock
                        </>
                      )}
                    </div>
                  )}

                  <section className="flex flex-col md:flex-row mt-[10px] ">
                    <form className="w-full">
                      <section className="flex md:flex-row flex-col">
                        {(availableStock || 0) <= 0 ? (
                          <Link to="/store-locator">
                            <SecondaryButton label={"Store Locator"} />
                          </Link>
                        ) : (
                          <SecondaryButton
                            label={isInCart ? "View Cart" : "Add to Cart"}
                            onClick={
                              isInCart ? handleCartAction : handleAddToCart
                            }
                            icon={isInCart ? <Eye /> : <ShoppingCart />}
                            className=""
                          />
                        )}
                      </section>
                    </form>
                  </section>
                </div>
              </section>

              <CartModal
                isCartModalVisible={isCartModalVisible}
                setIsCartModalVisible={setIsCartModalVisible}
                addedProduct={addedProduct}
                handleDecrease={handleProductDecrease}
                handleIncrease={handleProductIncrease}
                availableStock={availableStock}
                quantity={0}
                isUpdating={isUpdating}
                isDecreasing={isDecreasing}
              />
              <Footer />
            </div>
          </>
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
};

export default AccessoriesProductPage;
